export enum RepairShopEnum {
  LMS = "LMS",
  PARKING_GO = "PARKING_GO",
  COMPOUND = "COMPOUND",
  SHOP_REPAIR = "SHOP_REPAIR",
}

export const formatTypeString = (string: string, t: (field: any) => string) => {
  let translatedString = "";
  switch (string) {
    case RepairShopEnum.LMS:
      translatedString = t("vehicleExit.locationType.lms");
      break;
    case RepairShopEnum.SHOP_REPAIR:
      translatedString = t("vehicleExit.locationType.shopRepair");
      break;
    case RepairShopEnum.COMPOUND:
      translatedString = t("vehicleExit.locationType.compound");
      break;
    case RepairShopEnum.PARKING_GO:
      translatedString = t("vehicleExit.locationType.parkingGo");
      break;
    default:
      break;
  }

  return translatedString;
};
